import { ClientInferRequest } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { translateApiError } from "#app/i18n/translateApiError";
import { ApiError } from "#shared/infra/apiError";

type UpdateMaterialLayoutNestingDto = ClientInferRequest<
  typeof contract.materialLayouts.updateNesting
>["body"];

export const updateMaterialLayoutNesting = async ({
  id,
  payload,
}: {
  id: string | undefined;
  payload: UpdateMaterialLayoutNestingDto;
}) => {
  if (!id) {
    return;
  }

  const response = await api.materialLayouts.updateNesting.mutation({
    params: {
      id,
    },
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  if (response.status >= 400) {
    throw new ApiError(translateApiError(response.body), response.status, response.body);
  }

  throw new ApiError("Failed to update MaterialLayout nesting", response.status, response.body);
};
